module.exports = __webpack_public_path__ + "img/face5.30bb1ddc.gif";